//
//
//
//
//


import { UserLog } from '@/utils/log'
import { App_User } from '@/data/user_info'
import LocalData from '@/utils/local_data'
import Service from '@/service/public'
import ServiceIndex from '@/service/index'
import log_mixin from '@/common/mixins/log'
import billboard_mixin from '../web_720/_billboard_mixin'
import BillboardCanvas from '@/views/building/_components/_billboard_canvas'
import ServiceBuilding from '@/service/building'
export default {
    name: 'WebPage',
    mixins: [
        log_mixin('楼盘VR列表'),
        billboard_mixin,
    ],
    data () {
        return {
            src: '',
            title: '',
            house: {},
            show_cover_view: false,
            building_id: '',
            current_house: {},
            current_item: null
        }
    },
    watch: {
        src (url) {
            window.location.replace(url)
        }
    },
    mounted () {
        this.setWebViewSrc(this.$route.query)
        this.getData()
        this.getCurrent()
        this.visitLog()
    },
    methods: {
        async getData() {
            const { building_id } = this.$route.query
            const data = await ServiceIndex.getBuilding(building_id)
            this.building_id = building_id
            this.title = data.name
            this.house = data
            if (data.current_houses && data.current_houses.length) {
                this.current_house = data.current_houses[0]
            }
        },
        openConsult () {
            const { building_id } = this.$route.query
            this.$clickLog('咨询', {
                building_name: this.title,
                building_id
            })
            this.$router.push({
                path:`/consultants/filter/main?id=${building_id}&name=${this.title}&page=VR`
            })
        },
        visitLog () {
            const { detailParam, link } = this.$route.query
            const building_param_str = decodeURIComponent(detailParam).split('=')
            if (building_param_str && building_param_str.length > 1) {
                const building_id = building_param_str[1]
                UserLog.viewBuildingVr(building_id, decodeURIComponent(this.title), link)
            }
        },
        setWebViewSrc (options) {
            const { link } = options
            if (link) {
                this.src = decodeURIComponent(link)
            }
            setTimeout(() => {
                this.show_cover_view = true
            }, 1000)
        },
        async getCurrent() {
            const { building_id, category_id } = this.$route.query
            const data = await ServiceBuilding.getImgs(building_id, 'layout', {
                subcategory: 'VR视频'
            })
            const layout_array = data.items.filter(({ id }) => {
                return id === Number(category_id)
            })
            this.current_item  = layout_array && layout_array.length ? layout_array[0] : null
            if (this.current_item && this.current_item.vr_url) {
                this.src = this.current_item.vr_url
            }
        },
        errorLoad (err) {
           console.error(err)
        }
    },
    components: {
        BillboardCanvas
    }
}
